export interface FileInfo {
  type: string;
  name: string;
  size: number;
  url?: string;
  subtitle?: string;
  file?: File;
  content?: string;
}

export function fileToFileInfo(file: File, content?: string): FileInfo {
  return {
    name: file.name,
    type: file.type,
    size: file.size,
    content,
    file,
    url: URL.createObjectURL(file),
  };
}

export function readFileAsURL(file: File): Promise<string> {
  return new Promise((resolve) => {
    const reader = new FileReader();

    reader.onload = function (ev: ProgressEvent<FileReader>) {
      const target = ev.currentTarget as FileReader;
      resolve(target.result as string);
    };

    reader.readAsDataURL(file);
  });
}
